import { useField, useFormikContext } from "formik";
import DatePickerBox from "react-date-picker";
import { RxCalendar } from "react-icons/rx";
import styled from "styled-components";
import cn from "../../../lib/cn";

const DatePickerWrapper = styled.div`
    .react-calendar {
        font-family: Urbanist, sans serif;
    }

    .react-date-picker__wrapper {
        border: none !important;
    }
    .react-date-picker {
        height: 45px;
    }
    @media (min-width: 1024px) {
        .react-date-picker {
            height: 47px;
        }
    }

    @media (min-width: 1536px) {
        .react-date-picker {
            height: 53px;
        }
    }
    .react-calendar__tile {
        color: #171d39;
        font-size: 1.5rem;
    }
    .react-calendar__tile:disabled {
        background-color: #dbdbdc !important;
    }
    .react-calendar__tile--now {
        background-color: white !important;
    }
    .react-calendar__tile--active {
        background-color: #171d39 !important;
        color: white;
        border-radius: 55%;
    }
    .react-calendar__navigation button:disabled {
        background-color: white !important;
    }
    .react-calendar__navigation__prev2-button {
        display: none;
    }
    .react-calendar__navigation__next2-button {
        display: none;
    }
    abbr[title] {
        text-decoration: none;
        color: #b5bec6;
        font-size: 1rem;
        font-weight: 500;
    }
`;
const LabeledDatePicker = ({ name, label, required, ...props }) => {
    const [field, meta, helpers] = useField(name);

    const { setFieldValue } = useFormikContext();
    const dateValue = field.value ? new Date(field.value) : null;
    return (
        <div className=" mb-2 w-full">
            <div
                className={` relative px-px py-[0.9px]  xl:py-0  border w-full  rounded-lg ${
                    meta.error && meta.touched
                        ? "border-red"
                        : "border-blue-400"
                } text-btn-s`}
            >
                {label && (
                    <label
                        htmlFor={name}
                        className={cn(
                            "text-xs lg:text-sm font-urbanist absolute left-1.8 -top-1 bg-white px-0.8 flex items-center gap-0.5 z-5"
                            // labelClass
                        )}
                    >
                        {label}{" "}
                        {required && <span className="text-red">*</span>}
                    </label>
                )}
                <DatePickerWrapper>
                    <DatePickerBox
                        {...props}
                        onChange={(val) => setFieldValue(name, val)}
                        value={dateValue}
                        dayPlaceholder="dd"
                        name="date"
                        monthPlaceholder="mm"
                        format="dd/MM/yyyy"
                        yearPlaceholder="yyyy"
                        // minDate={new Date()}
                        // maxDate={maxDate}
                        clearIcon={null}
                        calendarIcon={<RxCalendar size={20} />}
                        className={`w-full flex border-none rounded-lg px-1 text-primary bg-transparent h-[40px] md:h-[53px] text-sm lg:text-base text-gray-secondary font-light font-vietnam ${
                            meta.touched && meta.error
                                ? "border-red-500"
                                : "border-gray-300"
                        }`}
                        calendarClassName="relative top-1 !border-2 !border-blue-400  bg-transparent rounded-lg"
                    />
                </DatePickerWrapper>
            </div>
            {meta.touched && meta.error && (
                <span className="text-red text-sm xl:text-base flex items-center flex-wrap gap-0.5">
                    {meta.error}*
                </span>
            )}
        </div>
    );
};

export default LabeledDatePicker;
